//Get Reducer Call--->
export const getOutstandingRequest = (page: number, size: number, search: string, from_date: Date, to_date: Date, collection_day: string) => ({
  type: 'GET_OUTSTANDING_REQUEST',
  payload: { page, size, search, from_date, to_date, collection_day },
});

export const getOutstandingSuccess = (data: any) => ({
  type: 'GET_OUTSTANDING_SUCCESS',
  payload: { data },
});

export const getOutstandingFailure = (data: string) => ({
  type: 'GET_OUTSTANDING_FAILURE',
  payload: { data },
});

export const resetGetOutstanding = () => ({
  type: 'RESET_GET_OUTSTANDING',
});
